import { Menu, MenuItem, MenuList } from '@chakra-ui/react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'

import MenuButton from 'components/menu-button'
import NotificationBadge from 'components/notification-badge'
import { useUserContext } from 'contexts/user-context'

import theme from 'theme'

const UserMenu = () => {
  const navigate = useNavigate()
  const { signOut, shouldNotifyNewVersion: hasNotification } = useUserContext()

  const queryClient = useQueryClient()
  const signOutMutation = useMutation({
    mutationFn: signOut,
    onSuccess: () => {
      queryClient.clear()
      window.localStorage.removeItem('fbx-customer')
      navigate('/login')
      window.location.reload()
    },
  })

  const { user } = useUserContext()

  return (
    <Menu>
      <MenuButton
        title={`${user?.given_name} ${user?.family_name}`}
        subTitle="User"
        css={{
          '&:hover': {
            background: theme.colors.gray['100'],
          },
          '&[data-active]': {
            background: theme.colors.gray['100'],
          },
        }}
        hasNotification={false}
      />
      <MenuList css={{ boxShadow: theme.shadows.md, marginRight: '5px' }}>
        <MenuItem onClick={() => navigate('/profile')}>Account profile</MenuItem>
        {/* <MenuItem
          onClick={() => navigate('/whats-new')}
          {...(hasNotification && {
            icon: <NotificationBadge />,
            iconSpacing: '8px',
          })}
        >
          What's New
        </MenuItem> */}
        <MenuItem onClick={() => signOutMutation.mutateAsync()}>Sign out</MenuItem>
      </MenuList>
    </Menu>
  )
}

export default UserMenu
